import ApiService from '../../service/apiServiceMaster.js';
const querystring = require('querystring')
var ForumService = {

    findAll: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "forums"
            $options.method = "get"

            if ($data) {
                $options.url = "forums?" + querystring.stringify($data)
            }
            ApiService.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },

    getForumList: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getForumList"
            $options.method = "get"

            if ($data) {
                $options.url = "getForumList?" + querystring.stringify($data)
            }
            ApiService.request($options)
            .then(response => {
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },

    getAction: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getAction"
            $options.method = "get"

            if ($data) {
                $options.url = "getAction?" + querystring.stringify($data)
            }
            ApiService.request($options)
            .then(response => {
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },

    getNotify: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getNotify"
            $options.method = "get"

            if ($data) {
                $options.url = "getNotify?" + querystring.stringify($data)
            }
            ApiService.request($options)
            .then(response => {
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
    getAllById: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getAllById"
            $options.method = "get"

            if ($data) {
                $options.url = "getAllById?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });
    },
    findOne: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "forums/" + $data
            $options.method = "get"
            if (!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                    // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
                })
        });

    },
    update: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.data = $data
            $options.url = "forums/" + $data.id;
            $options.method = "post"
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        })
    },
    save: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "forums" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    },

    create: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "forums";
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    }
};
export default ForumService;